import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "app-mfa-setup",
  templateUrl: "./mfa-setup.component.html",
  styleUrl: "./mfa-setup.component.scss",
})
export class MfaSetupComponent implements OnInit {
  @Input() qrCodeValue: string = ""; // The URL or data for the QR code
  @Input() secretCode: string = ""; // The backup code to show
  @Output() nextStep = new EventEmitter<void>();
  copiedToClipboard = false;

  public qrCodeDimension = 200;

  helpText =
    "Open an authenticator app <br>(e.g., like Authy, 1Password, Microsoft Authenticator, or Google Authenticator) and scan the image below using your phone's camera.";

  showSecretCodeOnMobile = false;

  toggleViewCode(): void {
    this.showSecretCodeOnMobile = !this.showSecretCodeOnMobile;
  }

  ngOnInit(): void {
    this.adjustQrCodeWidth(); // Set initial width on load
  }

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.adjustQrCodeWidth();
  }

  private adjustQrCodeWidth(): void {
    if (window.innerWidth < 768) {
      // For mobile screens, smaller size
      this.qrCodeDimension = 150;
      this.helpText =
        "Open an authenticator app, copy the set up code and enter it in the app";
    } else {
      // For larger screens
      this.qrCodeDimension = 200;
      this.helpText =
        "Open an authenticator app <br>(e.g., like Authy, 1Password, Microsoft Authenticator, or Google Authenticator) and scan the image below using your phone's camera.";
    }
  }

  copySecretCode(): void {
    const secret = this.getFormattedSecretCode().join(" ");
    navigator.clipboard.writeText(secret).then(
      () => {
        this.copiedToClipboard = true;

        setTimeout(() => {
          this.copiedToClipboard = false;
        }, 5000);
      },
      (err) => {
        console.error("Failed to copy code:", err);
      }
    );
  }

  getFormattedSecretCode(): string[] {
    // Split the secret code into groups of 4 characters
    return this.secretCode?.match(/.{1,4}/g) || [];
  }

  proceedToNextStep() {
    console.log("Next button clicked");
    this.nextStep.emit();
    // Implement your logic for proceeding to the next step
  }
}
